import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import styles from './styles.module.css';
import ResultPopup from "./ResultPopup";
import { useDispatch, useSelector } from "react-redux";
import { rouletteresult } from "../../../../store/slices/casinoResultsSlice";
import PlayerHistoryPopup from "../../Dragon_Tiger/PlayerHistoryPopup";


const numbers = [1, 4, 7, 12, 13, 17, 21, 24, 34, 36];
const blackNumbers = [2, 4, 6, 8, 10, 11, 17, 20, 22, 24, 26, 28, 29, 32, 35];

export default function ResultsScreen() {
    const [open, setOpen] = useState(false);
    const [selectedResult, setSelectedResult] = useState(null);
    const dispatch = useDispatch();
// const [historyOpen, setHistoryOpen] = useState(false);

    const resultData = useSelector((state) => state.casinoResults.roulette);

    useEffect(() => {
        dispatch(rouletteresult());
    }, [dispatch]);

    const handleOpen = (result) => {
        setSelectedResult(result);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedResult(null);
    };

    return (
        <>
            <Box className={styles.FooterLinks_container}>
                <Box className={styles.FooterLinks_box}>
                    <Box>
                        <Typography className={styles.FooterLinks_txt}>Last Result</Typography>
                    </Box>
                    <Box>
                        <Typography className={styles.FooterLinks_txt}>|</Typography>
                    </Box>
              <Box sx={{ cursor: 'pointer' }} onClick={() => (window.location.href = '/casino-results?game=Roulette')}>
    <Typography className={styles.FooterLinks_txt}>View All</Typography>
</Box>
                </Box>
                
            </Box>

            <Box className={styles.gameHistory_container}>
                {Array.isArray(resultData) && resultData.map((result, index) => (
                    <Box
                        key={result.roundId}
                        onClick={() => handleOpen(result)}
                        sx={{
                            background: result.color === "BLACK" ? "#383838" : 
                                        result.number === "0" ? "#008000" : "#DA2D2D",
                        }}
                        className={styles.gameHistory_circle}
                    >
                        <Typography className={styles.gameHistory_circle_txt}>
                            {result.number}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <ResultPopup
                open={open}
                handleClose={handleClose}
                selectedNumber={selectedResult?.number}
                resultData={selectedResult}
            />
       
        </>
    );
}